<template>
  <div
    v-if="statusLabel"
    class="c-product-card-status-label"
    :class="[productStatus, position, type]"
    v-html="statusLabel"
  ></div>
</template>

<script>
export default {
  name: 'ComponentsProductCardStatusLabel',
  props: {
    productStatus: {
      type: String,
      required: true,
    },
    position: { type: String, default: 'top right' },
    type: { type: String, default: 'triangle' },
  },
  computed: {
    statusLabel() {
      switch (this.productStatus) {
        case 'presale':
          return '予約購入<br>受付中'
        case 'backstock':
          return '入荷待ち<br>受付中'
        case 'soldout':
          return 'SOLD<br>OUT'
        default:
          return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-card-status-label {
  display: flex;
  font-size: 12px;
  color: #fff;
  text-align: center;
  padding: 8px 3px;
  z-index: 1;

  &.triangle {
    height: 88px;
    width: 88px;

    &.right {
      padding-left: 28px;
    }
  }

  &.triangle,
  &.triangle-small {
    display: block;
    text-align: center;

    &.bottom {
      align-items: flex-end;
      display: flex;
    }

    &.top.right {
      background: linear-gradient(
        45deg,
        transparent 50%,
        variables.$color-text-gray 50%
      );
    }

    &.bottom.left {
      background: linear-gradient(
        45deg,
        variables.$color-text-gray 50%,
        transparent 50%
      );
    }
  }

  &.badge {
    background-color: variables.$color-brown;
    border-radius: 4px;
    display: inline-block;
    font-size: 10px;
    font-weight: 300;
    line-height: 16.5px;
    padding: 1px 4px;

    &.soldout {
      background-color: variables.$color-text-gray;
    }
  }

  &.triangle-small {
    font-size: 7px;
    font-weight: bold;
    height: 52px;
    padding: 5px 3px;
    width: 52px;

    &.right {
      padding-left: 17px;
    }
  }
}
</style>

<style lang="scss">
.badge br {
  display: none;
}
</style>
